module.exports = __webpack_public_path__ + "img/header-bg-success.7c32f475.png";